export default __webpack_public_path__ + "static/media/igloo_3.a3848f06.jpg";